import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-talk.component',
  imports: [CommonModule],
  templateUrl: './talk.component.html',
  styleUrl: './talk.component.scss',
})
export class TalkComponent {
  page_status = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.page_status = true;
  }

  goBack(): void { this.page_status = false; }

  
}
